import { UserViewController } from './user-view.controller';
import { UserViewProps } from './user-view.model';

export const UserView = (props: UserViewProps) => {
  return <UserViewController {...props} />;
};
